import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import BrickWall from "../components/brick-wall"

function IndexPage() {

  const data = useStaticQuery(graphql`query NewsItems {
  news: allMarkdownRemark(
    filter: {frontmatter: {templateKey: {eq: "news"}}}
    sort: {frontmatter: {date: DESC}}
    limit: 6
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          templateKey
          title
          url
          caption
          ...UlaeHeroImage
        }
        bio: rawMarkdownBody
      }
    }
  }
  history: allMarkdownRemark(
    filter: {frontmatter: {templateKey: {eq: "history"}, showHome: {eq: true}}}
    sort: {frontmatter: {date: DESC}}
    limit: 33
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          templateKey
          title
          caption
          ...UlaeHeroImage
        }
        bio: rawMarkdownBody
      }
    }
  }
}`)

  return (
    <Layout>
      <Seo title="Universal Limited Art Editions" canonical="/" />
      <BrickWall key="bw" news={data.news} history={data.history}/>
    </Layout>
  )
}

export default IndexPage
